import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import React from 'react';

import ForgotPassword from '@/src/authentication/forgotPassword/containers/ForgotPassword';

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;

export const getStaticProps = async ({locale}) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});
